import React, { useEffect, useState } from 'react'
import axiosInstance, { API_BASE } from '../apiconfig'
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import Select from 'react-select'
import CommonFilter from '../components/CommonFilter'   // ✅ SHARED FILTER

const API = `${API_BASE}/api/milkrecords`
const FARMERS_API = `${API_BASE}/api/farmers/GetFarmers`

export default function MilkRecords() {

  const [farmers, setFarmers] = useState([])
  const [form, setForm] = useState({
    farmerId: 0,
    qty: 0,
    rate: 0,
    rsOnUs: 0,
    date: new Date().toISOString().slice(0, 10)
  })
  const [ocrFile, setOcrFile] = useState(null);
  const [ocrDate, setOcrDate] = useState(new Date().toISOString().slice(0, 10));
  const [uploading, setUploading] = useState(false);

  const [editing, setEditing] = useState(null)
  const [open, setOpen] = useState(false)

  const [monthYear, setMonthYear] = useState(
    new Date().toISOString().slice(0, 7)
  )
  const [filterFarmerId, setFilterFarmerId] = useState(0)

  const [rows, setRows] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
  })

  /* ================= FARMER OPTIONS (for filter) ================= */
  const farmerOptions = farmers.map(f => ({
    value: f.id,
    label: `(${f.code}) ${f.firstName} ${f.lastName}`
  }))

  /* ================= TABLE COLUMNS ================= */
  const columns = [
    { field: "id", headerName: "ID", width: 80 },

    {
      field: "farmerName",
      headerName: "Farmer",
      flex: 1,
      minWidth: 220,
      renderCell: (params) =>
        `(${params.row?.farmer?.code}) ${params.row?.farmer?.firstName || ""} ${params.row?.farmer?.lastName || ""}`
    },

    { field: "qty", headerName: "Qty", width: 100 },
    { field: "rate", headerName: "Rate", width: 100 },
    { field: "price", headerName: "Price", width: 120 },

    {
      field: "date",
      headerName: "Date",
      width: 120,
      renderCell: (params) => {
        if (!params.value) return "";
        const d = new Date(params.value);

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}/${month}/${year}`;
      }
    },

    {
      field: "actions",
      type: "actions",
      width: 120,
      getActions: (params) => [
        <GridActionsCellItem
          key={`edit-${params.id}`}
          icon={<EditIcon />}
          label="Edit"
          onClick={() => startEdit(params.row)}
        />,
        <GridActionsCellItem
          key={`delete-${params.id}`}
          icon={<DeleteIcon />}
          label="Delete"
          onClick={() => del(params.row.id)}
        />,
      ],
    },
  ]

  /* ================= EFFECTS ================= */
  useEffect(() => {
    fetchFarmers()
  }, [])

  useEffect(() => {
    fetchList()
  }, [paginationModel.page, paginationModel.pageSize, monthYear, filterFarmerId])

  /* ================= API CALLS ================= */
  const fetchFarmers = async () => {
    const r = await axiosInstance.get(FARMERS_API)
    setFarmers(r?.data ?? [])
  }

  const fetchList = async () => {
    setLoading(true)

    const res = await axiosInstance.get(API, {
      params: {
        page: paginationModel.page + 1,
        pageSize: paginationModel.pageSize,
        dateTime: new Date(`${monthYear}-01`),
        filterFarmerId: filterFarmerId || 0
      },
    })

    setRows(res?.data?.data ?? [])
    setTotal(res?.data?.totalCount ?? 0)
    setLoading(false)
  }

  /* ================= FORM ACTIONS ================= */
  const submit = async (e) => {
    e.preventDefault()

    const payload = {
      ...form,
      qty: parseFloat(form.qty),
      rate: parseFloat(form.rate),
      rsOnUs: parseFloat(form.rsOnUs),
      date: form.date
    }

    if (editing) {
      await axiosInstance.put(`${API}/${editing}`, payload)
    } else {
      await axiosInstance.post(API, payload)
    }

    resetForm()
    fetchList()
  }

  const startEdit = (r) => {
    setEditing(r.id)
    setOpen(true)
    setForm({
      farmerId: r.farmerId,
      qty: r.qty,
      rate: r.rate,
      rsOnUs: r.rsOnUs,
      date: r.date ? r.date.split('T')[0] : new Date().toISOString().slice(0, 10)
    })
  }

  const del = async (id) => {
    if (!confirm('You want to Delete?')) return
    await axiosInstance.delete(`${API}/${id}`)
    fetchList()
  }

  const resetForm = () => {
    setEditing(null)
    setForm({
      farmerId: 0,
      qty: 0,
      rate: 0,
      rsOnUs: 0,
      date: new Date().toISOString().slice(0, 10)
    })
  }


  const uploadFile = async () => {
    if (!ocrFile) return alert("Select file");

    try {
      setUploading(true);

      const fd = new FormData();
      fd.append("file", ocrFile);
      fd.append("date", `${ocrDate}T00:00:00`);


      var res = await axiosInstance.post(
        `${API_BASE}/api/ReadOcr/ocr`,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );


      setOcrFile(null);
      //setOcrDate(null);
      fetchList();
      alert(res?.data?.message);

    } finally {
      setUploading(false);
    }
  };


  /* ================= UI ================= */
  return (
    <div>

      {/* ================= ADD / EDIT FORM ================= */}
      <div className="panel">
        <div className="panel-header" onClick={() => setOpen(!open)}>
          <h3>Add / Edit Milk Record</h3>
          <span className={open ? "rotate" : ""}>▼</span>
        </div>

        <div className={`collapse ${open ? "open" : ""}`}>
          <div className="panel-body">
            <form onSubmit={submit} className="form">

              <label>Farmerss
                <Select
                  classNamePrefix="react-select"
                  placeholder="Search Farmer"
                  isClearable
                  isSearchable
                  options={farmerOptions}
                  value={farmerOptions.find(o => o.value === form.farmerId) || null}
                  onChange={(opt) =>
                    setForm({ ...form, farmerId: opt ? opt.value : 0 })
                  }
                />
              </label>
  
              <label>Qty
                <input
                  type="number"
                  value={form.qty}
                  onChange={e => setForm({ ...form, qty: e.target.value })}
                />
              </label>

              <label>Rate
                <input
                  type="number"
                  value={form.rate}
                  onChange={e => setForm({ ...form, rate: e.target.value })}
                />
              </label>

              <label>Date
                <input
                  type="date"
                  value={form.date}
                  onChange={e => setForm({ ...form, date: e.target.value })}
                />
              </label>

              <div className="actions">
                <button type="submit">
                  {editing ? 'Update' : 'Create'}
                </button>
                {editing && (
                  <button type="button" onClick={resetForm}>
                    Cancel
                  </button>
                )}
              </div>

            </form>

            <div style={styles.uploadWrapper}>
              <div style={styles.uploadHeader}>
                📷 Upload Farmer Milk Record Image
              </div>

              <div style={styles.uploadBox}>

                <div style={styles.fieldBlock}>
                  <label style={styles.label}>Date</label>
                  <input
                    type="date"
                    style={styles.formInput}
                    value={ocrDate}
                    onChange={(e) => setOcrDate(e.target.value)}
                  />
                </div>

                <div style={styles.fieldBlock}>
                  <label style={styles.label}>Image</label>

                  <label style={styles.fileLabel}>
                    Choose Image
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={(e) => setOcrFile(e.target.files[0])}
                      key={ocrFile ? ocrFile.name : "empty"}
                    />
                  </label>

                  {ocrFile && (
                    <span style={styles.fileName}>
                      {ocrFile.name}
                    </span>
                  )}
                </div>

                <div style={styles.buttonBlock}>
                  <button
                    type="button"
                    style={{
                      ...styles.uploadBtn,
                      opacity: uploading ? 0.7 : 1,
                      cursor: uploading ? "not-allowed" : "pointer",
                    }}
                    onClick={uploadFile}
                    disabled={uploading}
                  >
                    {uploading ? "Uploading..." : "Upload File"}
                  </button>
                </div>

              </div>
            </div>


          </div>
        </div>
      </div>

      {/* ================= SHARED FILTER ================= */}
      <CommonFilter
        loading={loading}
        filters={[
          {
            key: "farmer",
            type: "select",
            placeholder: "Search Farmer",
            options: farmerOptions,
            value: filterFarmerId,
            onChange: setFilterFarmerId,
          },
          {
            key: "month",
            type: "month",
            value: monthYear,
            onChange: setMonthYear,
          },
        ]}
        onClear={() => {
          setFilterFarmerId(0)
          setMonthYear(new Date().toISOString().slice(0, 7))
        }}
      />

      {/* ================= GRID ================= */}
      <div className="data">
        <DataGrid
          rows={rows}
          columns={columns}
          rowCount={total}
          loading={loading}
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[10, 20, 50, 100]}
          columnVisibilityModel={{ id: false }}

        />
      </div>

    </div>
  )
}

const styles = {
  uploadWrapper: {
    marginTop: 18,
  },

  uploadHeader: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 10,
    color: "#1f2937",
  },

  uploadBox: {
    border: "2px dashed #d1d5db",
    padding: 20,
    borderRadius: 12,
    display: "flex",
    alignItems: "flex-end",
    gap: 20,
    flexWrap: "wrap",
    background: "#f9fafb",
  },

  fieldBlock: {
    display: "flex",
    flexDirection: "column",
    minWidth: 180,
  },

  label: {
    fontSize: 13,
    marginBottom: 6,
    fontWeight: 500,
    color: "#374151",
  },

  fileLabel: {
    padding: "8px 14px",
    background: "#1976d2",
    color: "#fff",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 14,
    textAlign: "center",
  },

  fileName: {
    marginTop: 6,
    fontSize: 13,
    color: "#333",
    maxWidth: 220,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  buttonBlock: {
    display: "flex",
    alignItems: "flex-end",
  },

  uploadBtn: {
    padding: "10px 18px",
    background: "#2e7d32",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 14,
  },

  formInput: {
    width: 180,
    padding: "8px 10px",
    borderRadius: 6,
    border: "1px solid #ccc",
    fontSize: 14,
  },
};


